
import { Graphics,Sprite,Texture,Text,Rectangle } from 'pixi.js';
import { Vector2,Vector3, EventDispatcher,MathUtils } from 'three';
import { Utils } from '../core/utils.js';
import { EVENT_SELECTED, EVENT_UNSELECTED, EVENT_KEY_RELEASED, EVENT_KEY_PRESSED,EVENT_DELETED,EVENT_MOVED } from '../core/events';
import { KeyboardListener } from './KeyboardManager';
import { Dimensioning } from '../core/dimensioning.js';

import * as arrowhead from '../../assets/arrow-up.svg';
import { selectionColor } from '../core/constants.js';

export class ArrowView extends Graphics {
    constructor(floorplan, options, arrow) {
        super();

        this.__eventDispatcher = new EventDispatcher();
        this.__floorplan = floorplan;
        this.__options = options;
        this.__arrow = arrow;

        this.__start = arrow.start || null;
        this.__end = arrow.end || null;

        this.__arrowHeadSprite = null;

        this.__arrowLineShape = new Graphics();
        
        
        this.__outerLine = new Graphics();
        this.__arrowLineShape.addChild(this.__outerLine);
        this.addChild(this.__arrowLineShape);
        this.__arrowLineShape.interactive = true;
        this.__arrowLineShape.buttonMode = true;
        this.__outerLine.interactive = true;
        this.__outerLine.buttonMode = true;
        this.__isDragging = false;
        this.__isSelected = true;
        this.__snapToGrid = false;
        this.__keyboard = new KeyboardListener();
        this.__mouseDownEvent = this.__dragStart.bind(this);
        this.__mouseUpEvent = this.__dragEnd.bind(this);
        this.__mouseMoveEvent = this.__dragMove.bind(this);
        this.__mouseOverEvent = this.__mouseOver.bind(this);
        this.__mouseOutEvent = this.__mouseOut.bind(this);
        this.__mouseClickEvent = this.__click.bind(this);

        this.__angle = 0;

        this.__keyListenerEvent = this.__keyListener.bind(this);
        this.__arrowUpdatedEvent = this.__drawUpdatedArrow.bind(this);

        this.on('mousedown', this.__mouseClickEvent).on('touchstart', this.__mouseClickEvent);
        this.on('mouseupoutside', this.__mouseUpEvent).on('touchendoutside', this.__mouseUpEvent);
        this.on('mouseup', this.__mouseUpEvent).on('touchend', this.__mouseUpEvent);
        this.on('mousemove', this.__mouseMoveEvent).on('touchmove', this.__mouseMoveEvent);
        this.on('mouseover', this.__mouseOverEvent).on('mouseout', this.__mouseOutEvent);

        this.__arrow.addEventListener(EVENT_MOVED, this.__arrowUpdatedEvent);
        this.__keyboard.addEventListener(EVENT_KEY_RELEASED, this.__keyListenerEvent);
        this.__keyboard.addEventListener(EVENT_KEY_PRESSED, this.__keyListenerEvent);
        this.drawArrow(this.__start.x,this.__start.y,this.__end.x,this.__end.y,30,'0x000000');
        this.__outerLine.alpha = 0.0;
    }

    __drawUpdatedArrow(evt) {
        
        if (this.selected) {
            this.__drawSelectedState();
            return;
        }
        this.__drawHoveredOffState();
        
    }

    

      drawArrow(fromx, fromy, tox, toy, arrowWidth, color){
        //variables to be used when creating the arrow
        var headlen = 16;
        var angle = Math.atan2(toy-fromy,tox-fromx);
        this.__angle = angle;
        this.__arrowLineShape.clear();
     
        //starting path of the arrow from the start square to the end square
        //and drawing the stroke
        this.__arrowLineShape.lineStyle(5, color,1.0);
        this.__arrowLineShape.beginFill(color, 1.0);
        this.__arrowLineShape.moveTo(fromx, fromy);
        this.__arrowLineShape.lineTo(tox, toy);

        //starting a new path from the head of the arrow to one of the sides of
        //the point
        this.__arrowLineShape.lineStyle(5, color,1.0);
        this.__arrowLineShape.beginFill(color, 1.0);
        this.__arrowLineShape.moveTo(tox, toy);
        this.__arrowLineShape.lineTo(tox-headlen*Math.cos(angle-Math.PI/7),
                   toy-headlen*Math.sin(angle-Math.PI/7));
     
        //path from the side point of the arrow, to the other side point
        this.__arrowLineShape.lineTo(tox-headlen*Math.cos(angle+Math.PI/7),
                   toy-headlen*Math.sin(angle+Math.PI/7));
     
        //path from the side point back to the tip of the arrow, and then
        //again to the opposite side point
        this.__arrowLineShape.lineTo(tox, toy);
        this.__arrowLineShape.lineTo(tox-headlen*Math.cos(angle-Math.PI/7),
                   toy-headlen*Math.sin(angle-Math.PI/7));
     
        //draws the paths created above
        this.__arrowLineShape.endFill();
        this.drawOutlineBox(0.0);
    }

    

    drawOutlineBox(alpha){
        let offset = 20;
        let points = [];
        let p1Start = this.__arrow.start.clone();
        let p1End = this.__arrowOffsetLocation(this.__arrow.start.clone(), offset);

        let p2Start = this.__arrow.end.clone();
        let p2End = this.__arrowOffsetLocation(this.__arrow.end.clone(), offset);

        let p1Start1 = this.__arrow.start.clone();
        let p1End1 = this.__arrowOffsetLocation(this.__arrow.start.clone(), -offset);

        let p2Start1 = this.__arrow.end.clone();
        let p2End1 = this.__arrowOffsetLocation(this.__arrow.end.clone(), -offset);

        let p1Center = this.__arrowOffsetLocation(this.__arrow.start.clone(), offset);
        let p2Center = this.__arrowOffsetLocation(this.__arrow.end.clone(), offset);

        let p1Center1 = this.__arrowOffsetLocation(this.__arrow.start.clone(), -offset);
        let p2Center1 = this.__arrowOffsetLocation(this.__arrow.end.clone(), -offset);

    
        points[0] = p1Start1;
        points[1] = p1End1;
        points[2] = p1Center1;
        points[3] = p2Center1;
        points[4] = p2End1;
        points[5] = p2End;
        points[6] = p1Center;
        points[7] = p2Center;
        points[8] = p1End;
        
        this.__outerLine.clear()
        this.__outerLine.lineStyle(2, selectionColor);
        this.__outerLine.beginFill(selectionColor, 0.1);
        this.__outerLine.drawPolygon(points);
        this.__outerLine.endFill();

    }

    

    __arrowNormal() {
        
        let arrowDirectionNormalized2D = this.__arrow.arrowDirectionNormalized();
        let arrowDirectionNormalized = new Vector3(arrowDirectionNormalized2D.x, arrowDirectionNormalized2D.y, 0);
        arrowDirectionNormalized.applyAxisAngle(new Vector3(0, 0, 1), 1.57);
        return arrowDirectionNormalized;
    }

    __arrowOffsetLocation(point2d, offset) {
        let arrowOutDirection = this.__arrowNormal();
        if (arrowOutDirection === null) {
            arrowOutDirection = new Vector3(0, 1, 0);
        }
        let bestLocation = point2d.add(arrowOutDirection.multiplyScalar(offset));
        return bestLocation;
    }


    __drawSelectedState() {
        this.drawArrow(this.__arrow.start.x,this.__arrow.start.y,this.__arrow.__end.x,this.__arrow.__end.y,30,selectionColor);
        this.__outerLine.alpha = 0.5
    }
    __drawHoveredOnState() {
        this.drawArrow(this.__arrow.__start.x,this.__arrow.__start.y,this.__arrow.__end.x,this.__arrow.__end.y,30,selectionColor);
        this.__outerLine.alpha = 0.5
    }
    __drawHoveredOffState() {
        this.drawArrow(this.__arrow.__start.x,this.__arrow.__start.y,this.__arrow.__end.x,this.__arrow.__end.y,30,'0x000000');
        this.__outerLine.alpha = 0.0
    }


    __deactivate() {
        this.off('mousedown', this.__mouseClickEvent).off('touchstart', this.__mouseClickEvent);
        this.off('mouseupoutside', this.__mouseUpEvent).off('touchendoutside', this.__mouseUpEvent);
        this.off('mouseup', this.__mouseUpEvent).off('touchend', this.__mouseUpEvent);
        this.off('mousemove', this.__mouseMoveEvent).off('touchmove', this.__mouseMoveEvent);
        this.off('mouseover', this.__mouseOverEvent).off('mouseout', this.__mouseOutEvent);
    }

    __keyListener(evt) {
        if (this.selected && evt.key === 'Delete') {
            this.__removeFromFloorplan();
        }

        if (evt.type === EVENT_KEY_PRESSED && evt.key === 'Shift') {
            this.__snapToGrid = true;
        }
        if (evt.type === EVENT_KEY_RELEASED && evt.key === 'Shift') {
            this.__snapToGrid = false;
        }
    }



    __click(evt) {
        // console.log(evt);
        this.selected = true; 
        this.__isDragging = true;
        this.__dragStart(evt);
        this.__drawSelectedState();
        if (evt !== undefined) {
            evt.stopPropagation();
        }
    }

    __mouseOver(evt) {
        if (!this.selected) {
            this.__drawHoveredOnState();
            evt.stopPropagation();
        }
    }

    __mouseOut(evt) {
        if (!this.selected) {
            this.__drawHoveredOffState();
            if (evt !== undefined) {
                evt.stopPropagation();
            }
        }
    }
    __dragStart(evt) {
        // console.log(evt)
        this.__isDragging = true;
        if(evt){
            this.__drawHoveredOffState();
            evt.stopPropagation();
        }        
    }

    __dragEnd(evt) {
        this.__isDragging = false;
        evt.stopPropagation();
    }

    __dragMove(evt) {
        if (this.__isDragging) {
            let co = evt.data.getLocalPosition(this.parent);
            let cmCo = new Vector2(co.x, co.y);
            this.__arrow.location = cmCo; //new Vector2(cmCo.x, cmCo.y);
            evt.stopPropagation();
        }
    }
        /**
         * The below method is necessary if the remove event was
         * triggered from within this view class. For example, this view
         * class keeps listening to the delete key pressed. In such a case
         * it is the job of this view class to call the "remove()" method of the
         * associated method. 
         */
    __removeFromFloorplan() {
        //Stub the sub-classes need to implement this functionality
    }

    remove() {
        this.off('mousedown', this.__mouseDownEvent).off('touchstart', this.__mouseDownEvent);
        this.off('mouseupoutside', this.__mouseUpEvent).off('touchendoutside', this.__mouseUpEvent);
        this.off('mouseup', this.__mouseUpEvent).off('touchend', this.__mouseUpEvent);
        this.off('mousemove', this.__mouseMoveEvent).off('touchmove', this.__mouseMoveEvent);
        this.off('mouseover', this.__mouseOverEvent).off('mouseout', this.__mouseOutEvent);
        this.off('click', this.__mouseClickEvent);
        this.__keyboard.removeEventListener(EVENT_KEY_RELEASED, this.__keyListenerEvent);
        this.__keyboard.removeEventListener(EVENT_KEY_PRESSED, this.__keyListenerEvent);
        this.__keyboard.remove();
        if (this.parent) {
            this.parent.removeChild(this);
        }
    }

    addFloorplanListener(type, listener) {
        this.__eventDispatcher.addEventListener(type, listener);
    }

    removeFloorplanListener(type, listener) {
        this.__eventDispatcher.removeEventListener(type, listener);
    }

    get floorplan(){
        return this.__floorplan;
    }

    get arrow(){
        return this.__arrow;
    }

    get selected() {
        return this.__isSelected;
    }

    set selected(flag) {
        this.__isSelected = flag;
        if (!this.__isSelected) {
            this.__drawHoveredOffState();
        }
        if (flag) {
            this.__eventDispatcher.dispatchEvent({ type: EVENT_SELECTED, item: this });
        } else {
            this.__eventDispatcher.dispatchEvent({ type: EVENT_UNSELECTED, item: this });
        }
    }

    get interactable() {
        return this.__interactable;
    }

    set interactable(flag) {
        this.__interactable = flag;
        this.interactive = flag;
        this.buttonMode = flag;
    }


}